export const audiences = [
  { key: 0, value: 'Canvas', text: 'Canvas' },
  { key: 1, value: 'Video', text: 'Video' },
  { key: 2, value: 'Website', text: 'Website' },
  { key: 3, value: 'All', text: 'All' }
];



// WEBPACK FOOTER //
// ./src/screens/AudienceBuilder/Audiences.js